<template>
  <div
    v-if="isLoading"
  >
    <div class="loader" />
  </div>
  <div
    v-else
    class="staff_list_area"
  >
    <ul>
      <li
        v-if="members.length <= 0"
        class="list_empty"
      >
        <slot name="empty">メンバーがいません</slot>
      </li>
      <organization-member
        v-for="organizationMember in members"
        :key="organizationMember.user_id"
        :clinic="clinic"
        :organization="organization"
        :member="organizationMember"
        :mode="mode"
        @update="updateOrganizationMembers"
        @remove="removeClinicUser"
        @add-contract="addContract"
      />
    </ul>
  </div>
</template>
<script>
  import OrganizationMember from "../organizations/organization_member.vue"
  import OrganizationApi from '../../../api/organizations.js'
  import ClinicApi from '../../../api/clinics.js'

  export default {
    components: {
      OrganizationMember,
    },
    props: {
      clinic: {
        type: Object,
        requires: true,
        default: null
      },
      organization: {
        type: Object,
        requires: true,
        default: null
      },
      organizationMembers: {
        type: Array,
        requires: false,
        default: null
      },
      mode: {
        type: String,
        requires: true,
        default: 'normal'
      }
    },
    data () {
      return {
        members: [],
        isLoading: false,
        isLocking: false
      }
    },
    computed: {
      organizationId: vm => vm.clinic && vm.clinic.organization_id,
      clinicId: vm => vm.clinic && vm.clinic.id,
    },
    watch: {
      organizationMembers (users) {
        this.members = users
      }
    },
    created () {
      if(this.organizationMembers) {
        this.members = this.organizationMembers
      } else {
        this.loadUsers()
      }
    },
    methods: {
      loadUsers() {
        this.isLoading = true
        OrganizationApi.getOrganizationClinicUsers(this.organizationId, this.clinicId).then((res) => {
          this.members = res.data.organization_members
        }).finally(() => {
          this.isLoading = false
        })
      },
      removeClinicUser(organizationMember, clinicUser) {
        if(this.isLocking === true) return
        this.isLocking = true

        ClinicApi.deleteClinicUser(clinicUser.id).then(() => {
          this.members.splice(this.members.map(m => m.id).indexOf(organizationMember.id), 1);
          this.$emit('update', this.members)
        }).finally(() => {
          this.isLocking = false
        })
      },
      updateOrganizationMembers(organizationMember) {
        this.members.splice(this.members.map( m => m.id ).indexOf(organizationMember.id), 1, organizationMember);
        this.$emit('update', this.members)
      },
      addContract() {
        this.$emit('add-contract')
      }
    }
  }
</script>
<style scoped>
.loader {
  font-size: 50px;
}
</style>
